var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5644,
    cy: 21.3036,
    r: 20.8856,
    fill: "#9826F2",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6104 20.8435C30.6104 25.8081 27.0062 30.4581 22.0822 31.8185C21.7471 31.9099 21.3816 31.9099 21.0466 31.8185C16.1225 30.4581 12.5183 25.8081 12.5183 20.8435V16.3864C12.5183 15.5539 13.1478 14.6097 13.9295 14.295L19.5846 11.9801C20.8537 11.4623 22.2852 11.4623 23.5543 11.9801L29.2094 14.295C29.981 14.6097 30.6206 15.5539 30.6206 16.3864L30.6104 20.8435Z",
    stroke: "#9826F2",
    strokeWidth: 1.30535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5645 22.2447C22.103 22.2447 22.6195 22.0307 23.0003 21.6499C23.3811 21.2691 23.595 20.7527 23.595 20.2141C23.595 19.6756 23.3811 19.1591 23.0003 18.7783C22.6195 18.3975 22.103 18.1836 21.5645 18.1836C21.0259 18.1836 20.5095 18.3975 20.1287 18.7783C19.7479 19.1591 19.5339 19.6756 19.5339 20.2141C19.5339 20.7527 19.7479 21.2691 20.1287 21.6499C20.5095 22.0307 21.0259 22.2447 21.5645 22.2447ZM21.5645 22.2447V25.2905",
    stroke: "#9826F2",
    strokeWidth: 1.30535,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultIcon);
export default __webpack_public_path__ + "static/media/vaultIcon.3bc77f784865f31398044884b9891d36.svg";
export { ForwardRef as ReactComponent };